export enum RolesEnum {
    Admin = 'Admin',
    Comercial = 'Comercial',
    AccountHolder = 'AccountHolder',
    Users = 'Users',
}

export enum RoleIdsEnum {
    Admin = 1,
    Comercial = 2,
    AccountHolder = 3,
    Users = 4,
}

export const RolesNumber  = [ 'Admin', 'Comercial', 'AccountHolder', 'Users']

export type RoleType = {
    id: number,
    name?: string,
    description?: string
};
